import { render, staticRenderFns } from "./TableCards.vue?vue&type=template&id=fe1c9f0c&scoped=true&"
import script from "./TableCards.vue?vue&type=script&lang=js&"
export * from "./TableCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1c9f0c",
  null
  
)

export default component.exports